import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ModalController } from 'ionic-angular';
import { ServerProvider } from '../../providers/server/server';
import { AlertController } from 'ionic-angular';
import { LoadingController } from 'ionic-angular';
import { PeriodicityFormatterProvider } from '../../providers/periodicity-formatter/periodicity-formatter';
import { Events } from 'ionic-angular';


@Component({
    selector: 'page-periodic-transaction-log',
    templateUrl: 'periodic-transaction-log.html',
})
export class PeriodicTransactionLogPage {
    user_id: any;
    periodic_transaction_log = [];

    constructor(public navCtrl: NavController, public navParams: NavParams,
        public server: ServerProvider, private alertCtrl: AlertController,
        public loadingCtrl: LoadingController, public periodicity_formatter: PeriodicityFormatterProvider,
        public modalCtrl: ModalController,public events: Events
    ) {
        this.user_id = JSON.parse(window.localStorage['account'])["currentUser"]["id"];


        this.fetch()
    }

    fetch(){
        let loader = this.loadingCtrl.create({
            content: "Bitte warten",
            duration: 5000
        });
        loader.present()
        this.server.getPeriodicTransactionLog(this.user_id).subscribe(
            data => {
                this.periodic_transaction_log = data.json()
                loader.dismiss()
            },
            error => {
                loader.dismiss()
            }
        )
    }


    ionViewDidLoad() {
        console.log('ionViewDidLoad PeriodicTransactionPage');
    }

}



// WEBPACK FOOTER //
// ./src/pages/periodic-transaction-log/periodic-transaction-log.ts